export interface AnnouncementInterface {
  title: string;
  subtitle: string;
  countdownDate: Date;
  countdownLabel: string;
  postCountdownLabel: string;
  showDaysOnly: boolean;
}

export class AnnouncementModel {
  title: string;
  subtitle: string;
  countdownDate: Date;
  countdownLabel: string;
  postCountdownLabel: string;
  showDaysOnly: boolean;

  constructor(data: AnnouncementInterface) {
    this.title = data.title;
    this.subtitle = data.subtitle;
    this.countdownDate = data.countdownDate;
    this.countdownLabel = data.countdownLabel;
    this.postCountdownLabel = data.postCountdownLabel;
    this.showDaysOnly = data.showDaysOnly;
  }
}
